function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck
import React from 'react';
import { IndexPath } from "../../devsupport";
export class MenuService {
  constructor() {
    _defineProperty(this, "createDescriptorForElement", (element, index) => {
      const groupIndices = React.Children.map(element.props.children, (child, row) => {
        return new IndexPath(row, index);
      });
      return {
        groupIndices,
        index: new IndexPath(index)
      };
    });

    _defineProperty(this, "createDescriptorForNestedElement", (element, groupDescriptor, index) => {
      return {
        index: new IndexPath(index, groupDescriptor.index.row),
        groupIndices: null
      };
    });
  }

}